import React from 'react';

export default function Home() {
  return (
    <main style={styles.container}>
        <h1>Contact</h1>
        <p>Email me at <a href="mailto:hello@aimbisgroup.com">hello@aimbisgroup.com</a></p>
    </main>
  );
}

const styles = {
    container: {
      fontFamily: 'sans-serif',
      maxWidth: '600px',
      margin: '2rem auto',
      padding: '1rem',
      lineHeight: 1.6
    },
    heading: {
      fontSize: '2.5rem',
      marginBottom: '0.2rem'
    },
  };
  